import React, { PropTypes } from 'react';
import { NitroHeading, NitroButton, NitroDivider, NitroParagraph, NitroPanel } from 'nitro-components';

import Status from '../../../../../components/utils/Status';

import styled from 'styled-components';
import { media } from 'style-utils';

const Header = styled.div`
  position: relative;
  margin: 32px 0;
  min-height: 32px;
`;

const ContentWrapper = styled.div`
  margin: 0 auto;
  width: 50%;
  ${media.mobile`
    width: 90%;
  `}
`;

const ConfirmationMessageInfo = styled.section`
  margin: 50px 0 100px 0;
  color: ${props => props.theme.color.base3};
  b {
    color: ${props => props.theme.color.theme};
    float: none;
  }
`;

//TODO Sriram & Mytreyi -- Instead of defining the component, call the Generic Error template component by passing the required params.

const statusList = [
  {
    icon: 'success',
    variant: 'success',
    value: 2
  },
  {
    icon: 'progress',
    variant: 'base-3',
    value: 4
  },
  {
    icon: 'declined',
    variant: 'failure',
    value: 3
  },
  {
    icon: 'error',
    variant: 'failure',
    value: 999
  }
];

const ConfirmationMessage = ({ quoteId, messageDetail, status, closeWindow }) => {
  const headindText = `Quote Ref: ${quoteId}`;

  const formattedStatus = statusList.find(s => s.value === status.value);

  return (
    <section>
      <Header>
        {quoteId && <NitroHeading label={headindText} align="center" size="1" />}
      </Header>
      <NitroPanel padding="64px 24px">

          <ContentWrapper>
            <Status iconSize="48" label={status.label} labelSize="2" {...formattedStatus} />

            <NitroDivider sidePanel />
            <ConfirmationMessageInfo>
              <NitroParagraph variant="base3" align="center" bold>
                <span dangerouslySetInnerHTML={{ __html: messageDetail }} />
              </NitroParagraph>
            </ConfirmationMessageInfo>
            <NitroButton size="small" block label="Close window" action={closeWindow} />
          </ContentWrapper>

      </NitroPanel>
    </section>
  );
};

ConfirmationMessage.propTypes = {
  quoteId: PropTypes.string,
  messageDetail: PropTypes.string.isRequired,
  status: PropTypes.object.isRequired,
  closeWindow: PropTypes.func.isRequired
};

export default ConfirmationMessage;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/components/Confirmation/ConfirmMessage.js